import { render, staticRenderFns } from "./PersonaInfo.vue?vue&type=template&id=622d23e9&scoped=true"
import script from "./PersonaInfo.vue?vue&type=script&lang=js"
export * from "./PersonaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d23e9",
  null
  
)

export default component.exports